import { getObject } from "./StorageHelpers";
import { oktaClient } from "../config/okta.config";
import { getUserAttributeObj } from "./UserHelper";
import { isEmpty } from "lodash";
const getRoles = () => {
    const role = getUserAttributeObj("role");

    if (isEmpty(role)) {
        setTimeout(() => {
            getRoles();
        }, 500);
    }
    return role ? [role] : [];
};

const getUserId = () => {
    const tokens = getObject("okta-token-storage");
    return tokens.accessToken.claims.userId;
};

const getUserEmail = () => {
    const tokens = getObject("okta-token-storage");
    return tokens.accessToken.claims.email;
};

const getToken = () => {
    const tokens = getObject("okta-token-storage");
    return tokens?.accessToken?.accessToken;
};

const refreshToken = (createAxiosResponseInterceptor) => {
    oktaClient.tokenManager.renew("accessToken");
    return oktaClient.tokenManager
        .renew("accessToken")
        .catch((error) => {
            window.location.pathname = "/auth/login";
            return Promise.reject(error);
        })
        .finally(createAxiosResponseInterceptor);
};

export { getRoles, getToken, getUserId, getUserEmail, refreshToken };
